var $ = require("jquery");

var createdEvents = {};

$.fn.nativeTrigger = function(eventName) {
	var customEvent = createdEvents[eventName];
	if(!customEvent) {
		createdEvents[eventName] = customEvent = document.createEvent("CustomEvent");
		customEvent.initEvent(eventName, true, true);
	}

	return this.each(function(i, el) {
		el.dispatchEvent(customEvent);
	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/libs/jqueryNativeTrigger.js
 **/